// extracted by mini-css-extract-plugin
module.exports = {"container":"notification-count-bubble_container_2pE"};